import React from 'react';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import Story from './Story';
import Carousel from './Carousel';
import './Welcome.css';

function Welcome({ subject }) {
  return (
    <main className="welcome">
      <Hero subject={subject} />
      <Carousel />
      <Story />
      <section className="welcome-footer-cta">
        <h2>Add yours to today's gallery.</h2>
        <Link to="/?canvas=1" className="hero-cta">Start Drawing</Link>
      </section>
    </main>
  );
}

export default Welcome;
